module.exports = __webpack_public_path__ + "static/media/Fuzz Modeler Low Gain VR.c4ef2ba.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/modeler/Fuzz Modeler Low Gain VR.mp3
// module id = aPL8
// module chunks = 12